import { FormControl, FormLabel, Input, FormErrorMessage, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const PriorityField = ({ value, onChange, error }) => {
  const { darkMode } = useSelector((state) => state.settings);
  return (
    <FormControl isInvalid={!!error} isRequired>
      <Tooltip label="Set the priority for this rate (higher = more important)." placement="top">
        <FormLabel color={darkMode ? 'white' : 'black'}>Priority</FormLabel>
      </Tooltip>
      <Input
        name="priority"
        type="number"
        value={value}
        onChange={onChange}
        placeholder="Priority"
        min={0}
        style={{
          background: darkMode ? '#1e2021' : 'white',
          color: `${darkMode ? '#f5f4f3' : 'inherit'}`,
          borderColor: `${darkMode ? '#565557' : '#007bff'}`
        }}
      />
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default PriorityField;
